import React, { useContext,useState, useEffect, useMemo, useRef } from 'react';

import axios from '../../../common/AxiosConfig';

import moment from 'moment';

import CustomGrid from '../customgrid';

import { AppContext } from '../../../../RoutesWithAuth';

import { Typography, Box, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';


import FormGroup from '../FormGroup';

import ReportPopup from './ReportCommonPopup';

import {RequestorMapping} from '../../../common/commons';
import { REPORT_RIGHTS, isReportRightApplicable, getReportResponseKey } from './reportRights';

import Dialog from '../Dialog';

const useStyles = makeStyles(() => ({
    dialogheader :{
        textAlign:'center',
        fontSize: '0.75rem',
        '& span' :{
            fontWeight : 'bold'
        },
        '& .modelheader' :{
            paddingBottom : '5px',
            fontWeight : 'bold'
        }
    },
    dialogWrapper : {
        width : '860px'
    },
    reportCard: {
        background: '#fff',
        overflow: 'hidden',
    },
    reportHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '16px 20px 12px',
        borderBottom: '1px solid #e8eaed',
        '& h6': {
            fontSize: '1.05rem',
            fontWeight: 700,
            color: '#1a1a2e',
            letterSpacing: '0.5px',
            margin: 0,
        },
    },
    controlsBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        background: '#fafbfc',
        borderBottom: '1px solid #e8eaed',
    },
    customRadioInputCls : {
        display: 'flex',
        alignItems: 'center',
        width : '140px',
        whiteSpace: 'nowrap',
    },
    customInputCls : {
        width : '140px',
    },
    formGroupCls : {
        width: '700px',
        minWidth: '700px'
    },
    gridWrapper: {
        // Style clickable values as modern links
        '& .btngridcel':{
            background: 'transparent',
            border: '0px solid transparent',
            outline: '0px',
            padding: '0px',
            fontSize: 'inherit',
            color: '#1a73e8',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'color 0.15s ease',
            '&:hover': {
                color: '#1557b0',
                textDecoration: 'underline',
            }
        },
        // Highlight Total row
        '& .cgrid-row:last-child': {
            background: '#eef2f7 !important',
            fontWeight: 600,
            '& .cgrid-cell': {
                fontWeight: 700,
                borderTop: '2px solid #c8cbce',
            }
        },
    },
    toggleChip: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        }
    },
    footer: {
        textAlign: 'center',
        padding: '12px 0 16px',
        fontSize: '0.82rem',
        color: '#5f6b7a',
        fontStyle: 'italic',
        letterSpacing: '0.2px',
    },
}));

// Request type definitions (columns in transposed view)
const REQUEST_TYPES = [
    ...REPORT_RIGHTS.map(right => ({ ...right, popupMapping: right.ticketType })),
    { key: 'total', abbr: 'Total', popupMapping: '%' },
];

// Closure reason definitions (rows in transposed view)
const CLOSED_TYPES = [
    { index: 0, mapping: 'active_relationship', name: 'Active Relationship' },
    { index: 1, mapping: 'Rental', name: 'Active Rentals' },
    { index: 2, mapping: 'subscriber', name: 'Active Vehicle Association' },
    { index: 3, mapping: 'customer', name: 'Current Customer' },
    { index: 4, mapping: 'litigation', name: 'Lit. Hold' },
    { index: 5, mapping: 'no_downstream', name: 'No Downstreams' },
    { index: 6, mapping: 'vehicle', name: 'No Vehicle' },
    { index: 7, mapping: 'out_of_scope', name: 'Out of Scope' },
    { index: 8, mapping: 'primary_or_remote', name: 'Primary or Remote Subscription' },
    { index: 9, mapping: 'total', name: 'Total' },
];

const POPUP_PAGE_SIZE = 75;
const EMPTY_POPUP_PAGINATION = { total_count: 0, total_pages: 0 };

function AutoClosedReport(props) {

    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const classes = useStyles();

    const today = moment()
    
    const [duration, setDuration] = useState(true)
    const [tableFooter, setTableFooter] = useState("All Requests")
    const [date, setDate] = useState(today)
    const [openModel, setOpenModel] = useState(false);
    const [modelData, setModelData] = useState([]);
    const [closedType, setClosedType] = useState("")
    const [autoClosedData, setAutoClosedData] = useState([])
    const [requestor, setRequestor] = useState("All")
    const [hideEmptyColumns, setHideEmptyColumns] = useState(true)
    const [popupQuery, setPopupQuery] = useState(null)
    const [popupPage, setPopupPage] = useState(1)
    const [popupPagination, setPopupPagination] = useState(EMPTY_POPUP_PAGINATION)
    const [popupLoading, setPopupLoading] = useState(false)
    const [popupError, setPopupError] = useState(null)
    // Only the response matching the latest request id may update the popup
    const popupRequestId = useRef(0)

    const dateParam = duration === true ? "" : (date && date.isValid() ? date.format("YYYY-MM") : "")

    const fetchPopupPage = (query, page) => {
        const requestId = ++popupRequestId.current;
        setPopupPage(page);
        setPopupLoading(true);
        setPopupError(null);

        axios.get('/reports/auto_closed/download_query_v2', {
            params: {
                duration: duration === true ? null : "Month",
                date: dateParam,
                request_type: query.request_type,
                closed_type: query.closed_type,
                requestor,
                page,
                page_size: POPUP_PAGE_SIZE
            },
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            if (requestId !== popupRequestId.current) return;
            const dsarIds = res.data?.dsar_ids || [];
            const pagination = res.data?.pagination || {};
            setModelData(dsarIds.map(({dsar_id, created_date, requestor, ticket_type})=>{
                return {
                    dsar_id,
                    ticket_type,
                    requestor,
                    created_date
                }
            }))
            setPopupPagination({
                total_count: pagination.total_count ?? dsarIds.length,
                total_pages: pagination.total_pages ?? 1
            });
            setPopupPage(pagination.page || page);
        }).catch(err => {
            if (requestId !== popupRequestId.current) return;
            console.log(err)
            setModelData([]);
            setPopupError("Unable to load auto closed requests. Please try again.");
        }).finally(() => {
            if (requestId === popupRequestId.current) setPopupLoading(false);
        })
    }

    const fetchPopupData = (request_type, closed_type, closed_type_name) => {
        const query = { request_type, closed_type };
        setPopupQuery(query);
        setClosedType(closed_type_name);
        setModelData([]);
        setPopupPagination(EMPTY_POPUP_PAGINATION);
        setOpenModel(true);
        fetchPopupPage(query, 1);
    }

    const closePopup = () => {
        popupRequestId.current++;
        setOpenModel(false);
        setPopupQuery(null);
        setPopupLoading(false);
        setPopupError(null);
    }

    useEffect(() => {
        if (openModel && popupQuery) {
            fetchPopupPage(popupQuery, 1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duration, dateParam, requestor])

    const createClickableRenderCell = (popupMapping) => (params) => {
        const val = params.value || 0;
        return val > 0 ? (
            <button
                className="btngridcel btn btn-link p-0"
                onClick={(e) => {
                    e.stopPropagation();
                    fetchPopupData(popupMapping, params.row.closedTypeMapping, params.row.closedTypeName);
                }}
            >
                {val}
            </button>
        ) : val;
    };

    const reportColumns = [
        {
            name: 'Closed Type',
            mapping: 'closedTypeName',
            width: 200,
            sortable: false,
            frozen: true,
            headerAlign: 'center'
        },
        ...REQUEST_TYPES.map((rt) => ({
            name: rt.abbr,
            mapping: rt.key,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: createClickableRenderCell(rt.popupMapping)
        }))
    ];

    // Determine which request-type columns have all-zero values
    const emptyColumnKeys = useMemo(() => {
        if (!autoClosedData || autoClosedData.length === 0) return new Set();
        const keys = new Set();
        REQUEST_TYPES.forEach((rt) => {
            if (rt.key === 'total' || !isReportRightApplicable(rt.key, requestor)) return;
            const allZero = autoClosedData.every((row) => !row[rt.key] || row[rt.key] === 0);
            if (allZero) keys.add(rt.key);
        });
        return keys;
    }, [autoClosedData, requestor]);

    const visibleColumns = useMemo(() => {
        const cols = reportColumns.filter((col) =>
            col.mapping === 'closedTypeName' || isReportRightApplicable(col.mapping, requestor));
        if (!hideEmptyColumns || emptyColumnKeys.size === 0) return cols;
        return cols.filter((col) => !emptyColumnKeys.has(col.mapping));
    }, [hideEmptyColumns, emptyColumnKeys, autoClosedData, requestor]);
    useEffect(() => {
        // UseEffect used to fetch the data from the backend
        if (authToken) {
            axios.get('/reports/auto_closed_v2', {
                params: {
                    duration: duration === true ? null : "Month",
                    date: duration === true ? "" :(date && date.isValid() ? date.format("YYYY-MM") : ""),
                    requestor
                },
                headers: {
                    Authorization: authToken
                }
            }).then(res => {
                // Transpose: closure reasons become rows, request types become columns
                const ACRdata = CLOSED_TYPES.map((ct) => {
                    const row = {
                        id: ct.mapping,
                        closedTypeName: ct.name,
                        closedTypeMapping: ct.mapping,
                    };
                    REQUEST_TYPES.forEach((rt) => {
                        const arr = res.data[getReportResponseKey(rt.key)];
                        row[rt.key] = arr ? arr[ct.index] : 0;
                    });
                    return row;
                });
                setAutoClosedData(ACRdata)
                setTableFooter( duration === true ? "All Requests"
                 : (date && date.isValid() ? date.format("MMMM YYYY") : "All Requests"))
                }).catch(err => {
                console.log(err)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, date, duration, requestor])

    return (
        <div className={classes.reportCard}>
            <div className={classes.reportHeader}>
                <Typography variant="h6">AUTO CLOSED REPORT</Typography>
            </div>
            <Box className={classes.controlsBar}>
                <Box flex={1}>
                    <FormGroup 
                        formWrapperClassName={classes.formGroupCls}
                fields={[{
                    type : 'checkbox',
                    name : 'duration',
                    label : 'All Requests',
                    customInputCls : classes.customRadioInputCls,
                    defaultOption : true,
                    size :2,
                },{
                    type : 'month',
                    name : "date",
                    label : "Select Month",
                    defaultOption : date.format("YYYY-MM"),
                    isDisabled : duration,
                    inputAdditionalProps : {
                        min : "2020-01",
                        max : today.format("YYYY-MM")
                    }
                },{
                    type : 'multiselect',
                    name : 'requestor',
                    label : 'Requestor',
                    isMulti : false,
                    removeCheckBox : true,
                    customInputCls : classes.customInputCls,
                    options : ["All", ...Object.values(RequestorMapping)],
                    defaultOption : 'All',
                    size : 2
                }]}
                disableFormActions = {true}
                    customFormUpdates={(formData)=>{
                        setDuration(formData["duration"])
                        setDate(moment(formData["date"]))
                        setRequestor(formData["requestor"])
                    }}
                />
                </Box>
                {emptyColumnKeys.size > 0 && (
                    <Chip
                        className={classes.toggleChip}
                        icon={hideEmptyColumns ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                        label={hideEmptyColumns ? `Show ${emptyColumnKeys.size} hidden` : "Hide empty columns"}
                        variant={hideEmptyColumns ? "filled" : "outlined"}
                        color={hideEmptyColumns ? "primary" : "default"}
                        size="small"
                        onClick={() => setHideEmptyColumns(!hideEmptyColumns)}
                    />
                )}
            </Box>
            <div className={classes.gridWrapper}>
                <CustomGrid
                    columns={visibleColumns}
                    rows={autoClosedData}
                    enableCustomFiltering={false}
                    showFilterButton={false}
                    showPagination={false}
                    showDownloadButton={false}
                    customHeight="calc(100vh - 350px)"
                    title="Auto Closed Report"
                />
            </div>
            <div className={classes.footer}>Auto Closed Count: {tableFooter}</div>
            <>
            {openModel && <Dialog
            isOpen={true}
            updateDialogStatus={closePopup}
            isLoading={popupLoading}
            dialogContent={(
                <>
                    {popupError && (
                        <Typography variant="body2" color="error" role="alert">{popupError}</Typography>
                    )}
                    {!popupError && !popupLoading && modelData.length === 0 && (
                        <Typography variant="body2">No auto closed requests found.</Typography>
                    )}
                    <ReportPopup
                        modelData={modelData}
                        serverPagination={{
                            currentPage: popupPage,
                            pageSize: POPUP_PAGE_SIZE,
                            totalCount: popupPagination.total_count,
                            totalPages: popupPagination.total_pages,
                            onPageChange: (page) => fetchPopupPage(popupQuery, page)
                        }}
                    />
                </>
            )}
            title={(
                <div className={classes.dialogheader}>
                            <div className='modelheader'>Auto Closed Requests</div>
                            <>
                                <span> Workflow : </span> {closedType}
                            </>
                        </div>
            )}
        />}
        
            </>
        </div>
    );
}

export default AutoClosedReport;
